import _ from 'lodash';

/**
 * Syncs the field array when selectedFields or suggestedGroups change.
 * Adds a field if empty, removes trailing empty fields if first field has no value.
 */
export default function syncFieldArray(selectedFields, suggestedGroups) {
  if (selectedFields.length === 0 && suggestedGroups.length > 0) {
    selectedFields.addField();
  }

  if (selectedFields.length > 1 && !_.get(selectedFields, '[0].group.value')) {
    const values = selectedFields.map(({ group } = {}) => group.value);
    for (let i = values.length - 1; i > 0; i--) {
      if (values[i] === '' && selectedFields[i]) {
        selectedFields.removeField(i);
      }
    }
  }
}
